<template>
  <section>
      <div class="fixed_page"  id="blurry">
        <div class="get-started">

          <div class="fixed_page">

            <div class="prizes_box">
              <h1>{{ getTranslations.visitor_prizes_prizes }}</h1>
              <img src="/static/images/icon-Prizes.png">
              <p>{{ getTranslations.visitor_prizes_play }} <span>{{ getTranslations.visitor_prizes_big }}</span></p>
            </div>

            <div class="grand_prizes_box" v-if="prize1">
              <h1>{{ getTranslations.visitor_prizes_grand_prizes }}</h1>
              <h2> {{ grandPrize.headline }} </h2>
              <img :src="grandPrize.imgUrl || '/static/images/prize_images/prize-grand.png'">
              <div class="info_row">
                <p>&#9432;</p>
                <a href="#" @click="openModal(1)">{{ getTranslations.visitor_prizes_how_win }}</a>
              </div>
            </div>
            <!-- start_circle -->
            <div class="circle_background">
              <div class="grand_prizes_box monthly" v-if="prize2" >
                <h1>{{ getTranslations.visitor_prizes_monthly_prizes }}</h1>
                <prize-carousel :type='1'/>
                <div class="info_row">
                  <p>&#9432;</p>
                  <a href="#" @click="openModal(2)">{{ getTranslations.visitor_prizes_how_win }}</a>
                </div>
              </div>
              <div class="grand_prizes_box instant" v-if="prize3" >
                <h1>{{ getTranslations.visitor_prizes_weekly_prizes }}</h1>
                <prize-carousel :type='2'/>
                <div class="info_row">
                  <p>&#9432;</p>
                  <a href="#" @click="openModal(3)">{{ getTranslations.visitor_prizes_how_win }}</a>
                </div>
              </div>


            </div>
            <!-- end circle -->
          </div>

        </div>
        <component :is="modalForSettings"  @close="storeModalForSettings(null)"></component>
      </div>
  </section>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex';
import 'owl.carousel';
import PrizeCarousel from './PrizeCarousel';
import Howtowin from './home/modals/Howtowin';


export default {
  name: 'prizes',
  data() {
    return {
      componentModalAnswer: null,
      grandPrize: {},
      prize1: 0,
      prize2: 0,
      prize3: 0,
    };
  },
  components: { Howtowin, PrizeCarousel },
  mounted() {
    // eslint-disable-next-line
    for (const [property] in this.getCarouselPrizes) {
      if (this.getCarouselPrizes[property].type === 'GRAND') {
        this.grandPrize = this.getCarouselPrizes[property];
        this.prize1 = 1;
      } else if (this.getCarouselPrizes[property].type === 'MONTHLY') {
        this.prize2 = 1;
      } else { this.prize3 = 1; }
    }
  },
  methods: {
    ...mapMutations('common', [
      'storeModalForSettings',
      'setHowItWinType',
    ]),
    translationPerQuantity(quantity) { // different method from translationPerType due to AR css
      return (quantity) > 1 ? this.getTranslations.visitor_prizes_winners_per : this.getTranslations.visitor_prizes_winner_per;
    },
    translationPerType(type) {
      if (type === this.prizeType.daily) return this.getTranslations.visitor_prizes_winners_per_day;
      if (type === this.prizeType.weekly) return this.getTranslations.visitor_prizes_winners_per_week;
      if (type === this.prizeType.monthly) return this.getTranslations.visitor_prizes_winners_per_month;
      return '';
    },
    openModal(i) {
      this.setHowItWinType(i);
      this.storeModalForSettings(Howtowin);
    },
  },
  computed: {
    ...mapState('common', [
      'modalForSettings',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'getLocale',
    ]),
    ...mapGetters('profile', [
      'getDailyPrize',
      'getWeeklyPrize',
      'getMonthlyPrize',
      'getCarouselPrizes',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Prizes.vue